import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { Icon } from "../../Common/Icon";

class ArrowRowCell extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool
  };

  static defaultProps = {
    className: "",
    isOpen: false
  };

  render() {
    return (
      <div role="cell" className={classNames("sorted-list__data --arrow --center", this.props.className)}>
        <button className={classNames("button", this.props.isOpen ? "button__arrow --up" : "button__arrow")}>
          <Icon id="arrow-down" className="button__arrow-icon" />
        </button>
      </div>
    );
  }
}

export default ArrowRowCell;



// WEBPACK FOOTER //
// ./src/components/Layout/SortedList/ArrowRowCell.js